import { useEffect, useState } from "react";
import { fetchOneReference } from "../../api/application/reference";
import type { Reference } from "../../api/infrastructure/reference.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";
import { showToast } from "../shared/global-tools/toast-system";

export default function useGetReference({
  referenceId,
  preloadData = true,
}: {
  referenceId?: number;
  preloadData?: boolean;
} = {}) {
  const [reference, setReference] = useState<Reference>();
  const [loading, setLoading] = useState<boolean>(false);

  const fetchReference = async (id: number) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      try {
        const result = await fetchOneReference(id);
        setReference(result);
      } catch (error) {
        console.error("Error fetching reference:", error);
        showToast("Error fetching reference", { severity: "error" });
      } finally {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (!preloadData) return;
    if (!referenceId) return;
    fetchReference(referenceId);
  }, [referenceId, preloadData]);

  return {
    reference,
    loadingReference: loading,
    fetchReference,
    setReference,
  };
}
